import AppFramesIndex from "./frame.vue";
import AppFramesList from "./list/list.vue";
import AppFramesItem from "./item/item.vue";

const routes = [
  {
    path: "/frame",
    component: AppFramesIndex,
    meta: {
      auth: {
        roles: "frame.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "frame.index",
        component: AppFramesList,
        meta: {
          auth: {
            roles: "frame.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "frame.create",
        component: AppFramesItem,
        meta: {
          auth: {
            roles: "frame.create",
            redirect: { name: "frame.index" }
          }
        }
      },
      {
        path: ":id",
        name: "frame.edit",
        component: AppFramesItem,
        meta: {
          auth: {
            roles: "frame.update",
            redirect: { name: "frame.index" }
          }
        }
      }
    ]
  }
];

export default routes;
